module.exports = __webpack_public_path__ + "static/media/icon_01.dc16ea1c.png";